import React from "react";
import styles from "./dzen.module.css";
import { colors } from "../../../constants/colors";

export const Dzen = ({ color }) => {
    return (
        <a
            className={styles.dzen}
            href="https://dzen.ru/sct_germany"
            target="_blank"
            rel="noopener noreferrer"
        >
            <svg
                width="169"
                height="169"
                viewBox="0 0 169 169"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_45_484)">
                    <path

                        fill="#0f0e0e"
                        stroke="0f0e0e"

                        d="M84.0337 168.01H84.7036C118.068 168.01 137.434 164.651 151.152 151.333C165.139 137.206 168.369 117.709 168.369 84.4749V83.5351C168.369 50.311 165.139 30.9445 151.152 16.677C137.444 3.3594 117.938 0 84.7136 0H84.0437C50.6797 0 31.3031 3.3594 17.5856 16.677C3.59808 30.8045 0.368652 50.311 0.368652 83.5351V84.4749C0.368652 117.699 3.59808 137.066 17.5856 151.333C31.1732 164.651 50.6797 168.01 84.0337 168.01Z"
                    />
                    <path
                        d="M148.369 82.7304C148.369 82.0906 147.849 81.5608 147.209 81.5308C124.246 80.661 110.271 77.732 100.494 67.955C90.6967 58.1581 87.7776 44.1724 86.9079 21.1596C86.8879 20.5198 86.358 20 85.7082 20H83.0291C82.3893 20 81.8594 20.5198 81.8295 21.1596C80.9597 44.1624 78.0406 58.1581 68.2437 67.955C58.4568 77.742 44.4911 80.661 21.5283 81.5308C20.8885 81.5508 20.3687 82.0806 20.3687 82.7304V85.4096C20.3687 86.0494 20.8885 86.5792 21.5283 86.6092C44.4911 87.4789 58.4667 90.408 68.2437 100.185C78.0206 109.962 80.9397 123.908 81.8195 146.83C81.8394 147.47 82.3693 147.99 83.0191 147.99H85.7082C86.348 147.99 86.8779 147.47 86.9079 146.83C87.7876 123.908 90.7067 109.962 100.484 100.185C110.271 90.398 124.236 87.4789 147.199 86.6092C147.839 86.5892 148.359 86.0594 148.359 85.4096V82.7304H148.369Z"
                        fill="#ffffff"
                        stroke="#ffffff"
                    />
                </g>

                <defs>
                    <clipPath id="clip0_45_484">
                        <rect
                            width="168.04"
                            height="168.04"
                            fill="white"
                            transform="translate(0.368652)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </a>
    );
};
